export default __webpack_public_path__ + "static/media/logo.93d970c2.png";